import useParallax from "../hooks/useParallax";
import type { PortfolioItem } from "../data/portfolio";

// Caption text lives one level up in PortfolioGrid, not here — this card sits
// inside the sliding track, whose `transform` creates its own stacking context,
// so nothing inside it can ever render above the grid's fixed fade/caption layers.
export default function PortfolioCard({ item }: { item: PortfolioItem }) {
  const { ref, offset } = useParallax<HTMLDivElement>(0.05, 40);

  return (
    <div
      ref={ref}
      className="group relative h-[420px] overflow-hidden bg-ink sm:h-[480px]"
    >
      <div
        className="absolute inset-0 will-change-transform"
        style={{ transform: `translateY(${offset}px)` }}
      >
        <img
          src={item.image}
          alt={item.title}
          draggable={false}
          loading="lazy"
          className="h-full w-full scale-125 object-cover opacity-80 transition-transform duration-500 ease-engineered group-hover:scale-[1.35]"
        />
      </div>
    </div>
  );
}
